import React from 'react'
import { change as changeFieldValue, formValueSelector, Field, reduxForm } from 'redux-form';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import $ from 'jquery';
import cadastrarUsuario from '../../../actions/usuario/cadastrarUsuarioPlataforma'
import {
    renderFieldDataNascimento,
    renderFieldCpfCnpj,
    renderFieldCpf,
    renderFieldEmail,
    renderFieldSelect,
    renderFieldTelefone,
    required,
    requiredCPF,
    renderFieldCnpj,
    requiredSelect
} from '../../../util/inputs';
import buscarUsuarioPorEmail from '../../../actions/usuario/buscarUsuarioPorEmail';
import { showSuccessMsg } from '../../../util/messagesUtil';
import ptBR from 'date-fns/locale/pt-BR';
import { registerLocale, setDefaultLocale } from 'react-datepicker';
import { renderFieldCep } from '../../../util/inputs';
import { URL } from '../../../util/ambienteActions';
import axios from 'axios';
import { SLOW_REQUEST_CONFIG } from '../../../util/loadingUtil';
import { camposTipoChavePix, paisesDDI } from '../../../util/constantsUtil';
import UsuarioLink from '../empresa/UsuarioLink';
import Select from 'react-select';

registerLocale('pt-BR', ptBR);
setDefaultLocale('pt-BR');


export const validate = (values) => {
    const errors = {};
    if (!values.nome) {
        errors.nome = 'Campo obrigatório'
    }
    if (!values.email) {
        errors.email = 'Campo obrigatório'
    }

    return errors
};

const renderField = ({
    input,
    label,
    type,
    css,
    max,
    readOnly,
    meta: { touched, error }
}) => (
    <div>
        <label className='mt-2'>{label}</label>
        <div>
            <input {...input} type={type}
                className={css}
                maxLength={max}
                id={input.name}
                style={{ borderColor: touched && error ? 'red' : '' }}
                disabled={readOnly}
                readOnly={readOnly} />
            {touched
                && (error && <span style={{ color: 'red' }}>{error}</span>)}
        </div>
    </div>
);

export class ModalCadastrarUsuarioAgencia extends React.Component {
    constructor(props) {
        super(props);
        this.fechar = this.fechar.bind(this);
        this.submit = this.submit.bind(this);
        this.selecionarPlataforma = this.selecionarPlataforma.bind(this);

        this.state = {
            plataformaClicada: null,
            tipoCampoChavePixSelecionado: null,
            tipoChavePixSelecionado: null,
            seNaoFoiAlteradoListaLinks: true,
        }
    }

    componentDidUpdate(prevProps) {
        if (prevProps.cidade !== this.props.cidade) {
            this.props.changeFieldValue('formularioCadastroUsuario',
                'localidade', this.props.cidade);
        }
    }

    pesquisarPorCep(event) {
        const CEP = event.target.value.replace(/\D/g, '');
        if (CEP.length === 8) {
            const url = `${URL}/cep/public/${CEP}`;
            axios.get(url, SLOW_REQUEST_CONFIG).then((resp) => {
                if (resp.status === 200) {
                    this.props.changeFieldValue('formularioCadastroUsuario',
                        'logradouro', resp.data.logradouro);
                    this.props.changeFieldValue('formularioCadastroUsuario',
                        'complemento', resp.data.complemento);
                    this.props.changeFieldValue('formularioCadastroUsuario',
                        'bairro', resp.data.bairro);
                    this.props.changeFieldValue('formularioCadastroUsuario',
                        'localidade', resp.data.localidade);
                    this.props.changeFieldValue('formularioCadastroUsuario',
                        'uf', resp.data.uf);
                }
            })
        }
        this.limparCampos();
    }

    limparCampos() {
        this.props.changeFieldValue('formularioCadastroUsuario',
            'logradouro', '');
        this.props.changeFieldValue('formularioCadastroUsuario',
            'complemento', '');
        this.props.changeFieldValue('formularioCadastroUsuario',
            'bairro', '');
        this.props.changeFieldValue('formularioCadastroUsuario',
            'localidade', '');
        this.props.changeFieldValue('formularioCadastroUsuario',
            'uf', '');
        this.props.changeFieldValue('formularioCadastroUsuario',
            'numero', '');
    }

    limparCamposPlataforma() {
        this.setState({ plataformaClicada: null });
        this.setState({ tipoCampoChavePixSelecionado: null });
    }

    selecionarPlataforma(elemento) {
        this.setState({ plataformaClicada: elemento.value });
    }

    onChangeTipoChavePix(elemento) {
        this.props.changeFieldValue('formularioCadastroUsuario',
            'chavePix', '');
        this.setState({ tipoCampoChavePixSelecionado: elemento.value })
        this.setState({ tipoChavePixSelecionado: elemento });
    }

    montarParametroUsuario(values) {
        const pais = paisesDDI.find(it => it.id === values.ddiUsuario.value)

        return {
            id: this.props.usuarioSelecionado.id,
            nome: values.nome,
            email: values.email,            
            roles: [],
            ddi: pais.ddi,
            siglaPais: pais.sigla,
            telefone: values.telefoneUsuario,
            cpf: values.cpf,
            plataforma: values.plataforma.value,
            pessoa: {
                id: this.props.usuarioSelecionado.pessoa ? this.props.usuarioSelecionado.pessoa.id : 0,
                rg: values.rg ? values.rg : null,              
                dataNascimento: values.dataNascimento ? values.dataNascimento : null,
                cnpjSite: values.cnpjSite ? values.cnpjSite : null,
                razaoSocial: values.razaoSocial ? values.razaoSocial : null,
                nomeFantasia: values.nomeFantasia ? values.nomeFantasia : null,
                inscEstadual: values.inscEstadual ? values.inscEstadual : null,
                dadosBancario: values.banco ? {
                    id: (this.props.usuarioSelecionado.pessoa && this.props.usuarioSelecionado.pessoa.dadosBancario && this.props.usuarioSelecionado.pessoa.dadosBancario.length ? this.props.usuarioSelecionado.pessoa.dadosBancario[0].id : 0),
                    agencia: values.agencia,
                    banco: values.banco,
                    conta: values.conta,
                    nomeConformeAConta: values.nomeConformeAConta,
                    tipoChavePix: values.tipoChavePix ? {
                        chave: values.tipoChavePix.value
                    } : null,
                    chavePix: values.chavePix,
                } : null,
                endereco: {
                    id: this.props.usuarioSelecionado.pessoa && this.props.usuarioSelecionado.pessoa.endereco ? this.props.usuarioSelecionado.pessoa.endereco.id : 0,
                    cep: values.cep,
                    logradouro: values.logradouro,
                    complemento: values.complemento,
                    bairro: values.bairro,
                    localidade: values.localidade,
                    uf: values.uf,
                    numero: values.numero
                },

                tipoPlano: values.tipoPlano ? values.tipoPlano.value : null,
                nomeAgencia: values.nomeAgencia ? values.nomeAgencia : null

            },
            links: this.props.linksSelecionados
        };
    }

    submit(values) {
        this.props.cadastrarUsuario(this.montarParametroUsuario(values))
            .then(() => {
                showSuccessMsg('Usuario cadastrado com sucesso');
                this.fechar();                
                this.fecharModal();
            });
    }

    fecharModal() {
        $('#modalCadastrarUsuarioAgencia')
            .modal('hide');
        $('#modalCadastrarUsuarioAgencia')
            .hide();
        $('.modalCadastrarUsuarioAgencia')
            .hide();
        this.limparCamposPlataforma();
    }

    fechar() {
        this.props.reset('formularioCadastroUsuario');
        this.props.buscarUsuarios();
        this.props.limparLinks();
        this.limparCamposPlataforma();
    }

    verificarTipoChavePixDefinidaOuSelecionada(tipoChave) {
        return (this.state.tipoCampoChavePixSelecionado && this.state.tipoCampoChavePixSelecionado == tipoChave)
            || (this.props.tipoChavePixSelecionado && this.props.tipoChavePixSelecionado == tipoChave);
    }

    exibirCampoChavePixSemMascaraPara(colecaoTipoChavePix) {
        return colecaoTipoChavePix.includes(this.state.tipoCampoChavePixSelecionado)
            || colecaoTipoChavePix.includes(this.props.tipoChavePixSelecionado);
    }
    exibirCampoChavePixComMascaraPara(tipoChave) {
        return tipoChave == (this.state.tipoCampoChavePixSelecionado && this.state.tipoCampoChavePixSelecionado)
            || tipoChave == (this.props.tipoChavePixSelecionado && this.props.tipoChavePixSelecionado);
    }

    verificaSeNaoFoiAlteradoLinks(valor) {
        this.setState({ seNaoFoiAlteradoListaLinks: valor });
    }

    exibirComboDDI(event) {    
        return (
            <div>
                <Select
                    {...event.input}                  
                    options={paisesDDI.map(elemento => ({
                      label: `${elemento.pais} ${elemento.ddi}`,
                      value: elemento.id
                    }))}
                    onChange={(value) => {
                      this.clearTelefone()
                      event.input.onChange(value);                    
                    }}
                />
                {event.meta.touched
                && (event.meta.error && <span style={{color: 'red'}}>{event.meta.error}</span>)}
          </div>
        )    
    }
  
    clearTelefone() {
      this.props.changeFieldValue('formularioCadastroUsuario', 'telefoneUsuario', '');
    }

    render() {
        const {
            handleSubmit, submitting, invalid
        } = this.props;
        return (
            <div className="modal fade show" id='modalCadastrarUsuarioAgencia' role='dialog'
                aria-labelledby='modalCadastrarUsuarioAgencia' aria-hidden='true' data-backdrop='static'>
                <div className={'modal-dialog modal-dialog-centered modal-lg'}>
                    <div className="modal-content" style={{borderTop:'4px solid #FF6A00', borderRadius:12}}>
                        <div className="modal-header" style={{borderBottom:'1px solid #f0f0f0'}}>
                            <h5 style={{display:'flex', alignItems:'center', gap:8, margin:0, fontSize:16, fontWeight:700}}>
                                <i className="material-icons" style={{color:'#FF6A00', fontSize:20}}>store</i>
                                Usuário Agência
                            </h5>
                            <button type="button" className="close" data-dismiss="modal" aria-label="Close"
                                onClick={() => this.fechar()}>
                                <i className="material-icons">close</i>
                            </button>
                        </div>
                        <div className="modal-body">
                            <form onSubmit={handleSubmit(this.submit)}>
                                <div className="form-row mt-2">
                                    <div className="col-12 col-sm-12 col-md-7">
                                        <Field name='plataforma'
                                            options={[
                                                {
                                                    descricao: 'adminagencia',
                                                    nome: 'adminagencia'
                                                },
                                            ]}
                                            component={renderFieldSelect}
                                            label='Plataforma'
                                            placeholder='Selecione...'
                                            disabled={true}
                                        />
                                    </div>
                                    <div className="col-12 col-sm-12 col-md-5">
                                        <Field name='tipoPlano'
                                            options={this.props.tipoPlano.map(elemento => ({
                                                descricao: elemento.valor,
                                                nome: elemento.chave
                                            }))}
                                            component={renderFieldSelect}
                                            label='Tipo Plano'
                                            placeholder='Selecione...'
                                        />
                                    </div>
                                </div>
                                <div className="form-row">
                                    <div className="col-12 col-sm-4 col-md-4">
                                        <Field name="email" type="email" component={renderFieldEmail} label="E-mail:"
                                            validate={[required]}
                                            css="form-control" readOnly={false} />
                                    </div>
                                    <div className="col-12 col-sm-4 col-md-4">
                                        <Field name="cpf" type="text" component={renderFieldCpf} label="CPF:"
                                            validate={[requiredCPF]}
                                            css="form-control" />
                                    </div>
                                    <div className="col-12 col-sm-4 col-md-4">
                                        <Field name="rg" type="text" max={15} component={renderField} label="RG:"
                                            validate={[required]}
                                            css="form-control" />
                                    </div>
                                </div>

                                <div className="form-row">
                                    <div className="col-12 col-sm-3 col-md-3">
                                        <Field name="nome" type="text" validate={[required]} component={renderField}
                                            label="Nome Completo:"
                                            css="form-control" />
                                    </div>
                                    <div className="col-12 col-sm-3 col-md-3" style={{position: 'relative', top: '4px'}}>
                                        <label>Código do País</label>
                                        <Field name='ddiUsuario'
                                            validate={requiredSelect} 
                                            component={this.exibirComboDDI.bind(this)} 
                                            css="form-control col-md-6" />
                                    </div>
                                    <div className="col-12 col-sm-2 col-md-2">
                                        <Field name="telefoneUsuario" type="text"
                                            component={renderFieldTelefone}
                                            css="form-control" label="Telefone" />
                                    </div>
                                    <div className="col-12 col-sm-3 col-md-3">
                                        <Field name="dataNascimento" type="text"
                                            component={renderFieldDataNascimento}
                                            label='Data de nascimento'
                                            validate={[required]}
                                            css="form-control" />
                                    </div>
                                </div>
                                <div className="form-row mt-2">                                                                       
                                    <UsuarioLink
                                        linksSelecionados={this.props.linksSelecionados}
                                        alterarValoresLinksSelecionados={this.props.alterarValoresLinksSelecionados}                                        
                                        verificaSeNaoFoiAlteradoLinks={this.verificaSeNaoFoiAlteradoLinks.bind(this)}
                                        classCss={'campoUrlModalUsuarioAgencia'}
                                        ehUsuarioAgencia={true}
                                    />
                                </div>
                                <div className="form-group area-codigo">
                                    <Field name="idUsuario" type="hidden" component={renderField}
                                        css="form-control col-md-12" />
                                </div>
                                <div>
                                    <div className="form-row">
                                        <div className="col-12 col-sm-4 col-md-4">
                                            <Field name="cnpjSite" type="text" component={renderFieldCnpj} label="CNPJ:"
                                                css="form-control" />
                                        </div>
                                        <div className="col-12 col-sm-4 col-md-4">
                                            <Field name="razaoSocial" type="text" component={renderField} label="Razão Social:"
                                                css="form-control" />
                                        </div>
                                        <div className="col-12 col-sm-4 col-md-4">
                                            <Field name="nomeFantasia" type="text" component={renderField} label="Nome Fantasia:"
                                                css="form-control" />
                                        </div>
                                        <div className="col-12 col-sm-4 col-md-4">
                                            <Field name="inscEstadual" type="text" component={renderField} label="Inscrição Estadual:"
                                                css="form-control" />
                                        </div>
                                        <div className="col-12 col-sm-2 col-md-2">
                                            <Field name="nomeAgencia" type="text" component={renderField} label="Agência:"
                                                validate={[required]} css="form-control" readOnly={false} />
                                        </div>
                                    </div>
                                    <div className="form-row">
                                        <div className="col-12 col-sm-3 col-md-3">
                                            <Field name="cep" type="text" component={renderFieldCep} label="CEP:"
                                                validate={[required]} css="form-control" readOnly={false} onChange={e => this.pesquisarPorCep(e)} />
                                        </div>
                                        <div className="col-12 col-sm-7 col-md-7">
                                            <Field name="logradouro" type="text" component={renderField} label="Logradouro:"
                                                validate={[required]} css="form-control" readOnly={false} />
                                        </div>
                                        <div className="col-12 col-sm-2 col-md-2">
                                            <Field name="numero" type="text" max={3} component={renderField} label="Número:"
                                                css="form-control" readOnly={false} />
                                        </div>
                                    </div>
                                    <div className="form-row">
                                        <div className="col-12 col-sm-5 col-md-5">
                                            <Field name="complemento" type="text" component={renderField} label="Complemento:"
                                                css="form-control" readOnly={false} />
                                        </div>
                                        <div className="col-12 col-sm-3 col-md-3">
                                            <Field name="bairro" type="text" component={renderField} label="Bairro:"
                                                validate={[required]} css="form-control" readOnly={false} />
                                        </div>
                                        <div className="col-12 col-sm-3 col-md-3">
                                            <Field name="localidade" type="text" component={renderField} label="Cidade:"
                                                validate={[required]} css="form-control" readOnly={false} />
                                        </div>
                                        <div className="col-12 col-sm-1 col-md-1">
                                            <Field name="uf" type="text" component={renderField} label="UF:" readOnly={true} css="form-control col-md-12" />
                                        </div>
                                    </div>
                                    <div className="form-row">
                                        <div className="col-12 col-sm-1 col-md-1">
                                            <Field name="banco" type="text" component={renderField} label="Banco:"
                                                validate={[required]} css="form-control" readOnly={false} />
                                        </div>
                                        <div className="col-12 col-sm-3 col-md-3">
                                            <Field name="conta" type="text" component={renderField} label="Conta:"
                                                validate={[required]} css="form-control" readOnly={false} />
                                        </div>
                                        <div className="col-12 col-sm-2 col-md-2">
                                            <Field name="agencia" type="text" component={renderField} label="Agência:"
                                                validate={[required]} css="form-control" readOnly={false} />
                                        </div>
                                        <div className="col-12 col-sm-6 col-md-6">
                                            <Field name="nomeConformeAConta" type="text" component={renderField} label="Nome Titular:"
                                                validate={[required]} css="form-control" readOnly={false} />
                                        </div>
                                    </div>
                                    <div className="form-row">
                                        <div className="col-12 col-sm-5 col-md-5">
                                            <Field name="tipoChavePix"
                                                options={camposTipoChavePix.map(elemento => ({
                                                    descricao: elemento.valor,
                                                    nome: elemento.chave
                                                }))}
                                                value={this.state.tipoChavePixSelecionado}
                                                component={renderFieldSelect}
                                                onChange={e => this.onChangeTipoChavePix(e)}
                                                label="Tipo Chave Pix"
                                                placeholder='Selecione Tipo Chave Pix' />
                                        </div>
                                        {!this.exibirCampoChavePixSemMascaraPara(['CPF_CNPJ', 'NUMERO_TELEFONE_CELULAR']) ?
                                            <div className="col-12 col-sm-7 col-md-7">
                                                <Field name="chavePix" type="text" component={renderField} label="Chave Pix:"
                                                    css="form-control" readOnly={false} />
                                            </div>
                                            : ''}
                                        {this.exibirCampoChavePixComMascaraPara('CPF_CNPJ') ?
                                            <div className="col-12 col-sm-7 col-md-7">
                                                <Field name="chavePix" type="text" component={renderFieldCpfCnpj} label="Chave Pix:"
                                                    css="form-control" readOnly={false} />
                                            </div>
                                            : ''}
                                        {this.exibirCampoChavePixComMascaraPara('NUMERO_TELEFONE_CELULAR') ?
                                            <div className="col-12 col-sm-7 col-md-7">
                                                <Field name="chavePix" type="text" component={renderFieldTelefone} label="Chave Pix:"
                                                    css="form-control" readOnly={false} />
                                            </div>
                                            : ''}

                                    </div>

                                </div>
                                <div className="modal-footer">
                                    <button id="btn-salvar" type="submit" disabled={(invalid || submitting || this.props.linksSelecionados.length <= 0)}
                                        className="btn btn-laranja">Salvar
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export function mapStateToProps(state) {    
    return {
        plataformas: state.plataformas,
        usuarioSelecionado: state.usuarioSelecionado,
        initialValues: {
            email: state.usuarioSelecionado.email,
            nome: state.usuarioSelecionado.nome,
            cpf: state.usuarioSelecionado.cpfCnpj,
            ddiUsuario: state.usuarioSelecionado.ddi && state.usuarioSelecionado.siglaPais ? {label: `${paisesDDI.find(it => it.sigla === state.usuarioSelecionado.siglaPais).pais} ${paisesDDI.find(it => it.sigla === state.usuarioSelecionado.siglaPais).ddi}`, value: paisesDDI.find(it => it.sigla === state.usuarioSelecionado.siglaPais).id} : {label: 'Brasil +55', value: 32},
            telefoneUsuario: state.usuarioSelecionado.telefone,
            plataforma: {
                label: 'adminagencia',
                value: 'adminagencia'
            },
            rg: state.usuarioSelecionado.pessoa ? state.usuarioSelecionado.pessoa.rg : '',
            dataNascimento: state.usuarioSelecionado.pessoa ? state.usuarioSelecionado.pessoa.dataNascimento : '',
            cnpjSite: state.usuarioSelecionado.pessoa ? state.usuarioSelecionado.pessoa.cnpjSite : '',
            razaoSocial: state.usuarioSelecionado.pessoa ? state.usuarioSelecionado.pessoa.razaoSocial : '',
            nomeFantasia: state.usuarioSelecionado.pessoa ? state.usuarioSelecionado.pessoa.nomeFantasia : '',
            inscEstadual: state.usuarioSelecionado.pessoa ? state.usuarioSelecionado.pessoa.inscEstadual : '',
            cep: state.usuarioSelecionado.pessoa && state.usuarioSelecionado.pessoa.endereco ? state.usuarioSelecionado.pessoa.endereco.cep : '',
            logradouro: state.usuarioSelecionado.pessoa && state.usuarioSelecionado.pessoa.endereco ? state.usuarioSelecionado.pessoa.endereco.logradouro : '',
            complemento: state.usuarioSelecionado.pessoa && state.usuarioSelecionado.pessoa.endereco ? state.usuarioSelecionado.pessoa.endereco.complemento : '',
            numero: state.usuarioSelecionado.pessoa && state.usuarioSelecionado.pessoa.endereco ? state.usuarioSelecionado.pessoa.endereco.numero : '',
            bairro: state.usuarioSelecionado.pessoa && state.usuarioSelecionado.pessoa.endereco ? state.usuarioSelecionado.pessoa.endereco.bairro : '',
            localidade: state.usuarioSelecionado.pessoa && state.usuarioSelecionado.pessoa.endereco ? state.usuarioSelecionado.pessoa.endereco.localidade : '',
            uf: state.usuarioSelecionado.pessoa && state.usuarioSelecionado.pessoa.endereco ? state.usuarioSelecionado.pessoa.endereco.uf : '',
            banco: state.usuarioSelecionado.pessoa && state.usuarioSelecionado.pessoa.dadosBancario && state.usuarioSelecionado.pessoa.dadosBancario.length ? state.usuarioSelecionado.pessoa.dadosBancario[0].banco : '',
            conta: state.usuarioSelecionado.pessoa && state.usuarioSelecionado.pessoa.dadosBancario && state.usuarioSelecionado.pessoa.dadosBancario.length ? state.usuarioSelecionado.pessoa.dadosBancario[0].conta : '',
            nomeConformeAConta: state.usuarioSelecionado.pessoa && state.usuarioSelecionado.pessoa.dadosBancario && state.usuarioSelecionado.pessoa.dadosBancario.length ? state.usuarioSelecionado.pessoa.dadosBancario[0].nomeConformeAConta : '',
            agencia: state.usuarioSelecionado.pessoa && state.usuarioSelecionado.pessoa.dadosBancario && state.usuarioSelecionado.pessoa.dadosBancario.length ? state.usuarioSelecionado.pessoa.dadosBancario[0].agencia : '',
            tipoChavePix: state.usuarioSelecionado.pessoa && state.usuarioSelecionado.pessoa.dadosBancario && state.usuarioSelecionado.pessoa.dadosBancario.length && state.usuarioSelecionado.pessoa.dadosBancario[0].tipoChavePix ? {
                label: state.usuarioSelecionado.pessoa.dadosBancario[0].tipoChavePix.valor,
                value: state.usuarioSelecionado.pessoa.dadosBancario[0].tipoChavePix.chave
            } : null,
            chavePix: state.usuarioSelecionado.pessoa && state.usuarioSelecionado.pessoa.dadosBancario && state.usuarioSelecionado.pessoa.dadosBancario.length ? state.usuarioSelecionado.pessoa.dadosBancario[0].chavePix : '',
            tipoPlano: state.usuarioSelecionado.pessoa && state.usuarioSelecionado.pessoa.tipoPlano ? {
                label: state.usuarioSelecionado.pessoa.tipoPlano.valor,
                value: state.usuarioSelecionado.pessoa.tipoPlano.chave,
            } : null,
            nomeAgencia : state.usuarioSelecionado.pessoa ? state.usuarioSelecionado.pessoa.nomeAgencia : ''

        },

        pessoa: state.usuarioSelecionado.pessoa,
        plataformaSelecionada: state.usuarioSelecionado.plataforma,
        dataNascimento: formValueSelector('formularioCadastroUsuario')(state, 'dataNascimento'),
        cidadeForm: formValueSelector('formularioCadastroUsuario')(state, 'cidadeForm'),
        ddiUsuario: formValueSelector('formularioCadastroUsuario')(state, 'ddiUsuario'),
        tipoPlano: state.usuarios.tipoPlanoDto || []
    }
}


export const mapDispatchToProps = dispatch => (
    bindActionCreators({
        changeFieldValue,
        cadastrarUsuario,        
        buscarUsuarioPorEmail,
    }, dispatch)
);

export default connect(mapStateToProps, mapDispatchToProps)(reduxForm({
    form: 'formularioCadastroUsuario',
    enableReinitialize: true,
    destroyOnUnmount: false,
    forceUnregisterOnUnmount: true
})(ModalCadastrarUsuarioAgencia));
